/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualSubjectId: core.serialization.ObjectSchema<
    serializers.NotEqualSubjectId.Raw,
    Truvity.NotEqualSubjectId
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualSubjectId {
    export interface Raw {
        value: string;
    }
}
